import { createTheme } from '@mui/material/styles';

const castingBotTheme = createTheme({
  typography: {
    fontSize: 13,
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#121212"
        }
      }
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        paper: {
          backgroundColor: '#121212'
        }
      }
    }
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#0984e3',
      light: '#259fff',
      dark: '#0868b3',
    },
    secondary: {
      main: '#74b9ff',
      light: '#000000',
    },
    background: {
      default: '#000000',
      paper: '#151515',
    },
    text: {
      primary: '#eeeeee',
      secondary: 'rgba(255,255,255,0.6)',
      hint: '#0a0712',
      disabled: 'rgba(47,47,47,0.52)',
    },
    error: {
      main: '#e63c2a',
      light: '#ff4030',
      dark: '#c0392b',
    },
    warning: {
      main: '#e8760f',
      dark: '#d35400',
      light: '#ff831c',
    },
    success: {
      main: '#10af51',
      light: '#36ff8e',
      dark: '#27ae60',
    },
    info: {
      main: '#2d5b87',
      dark: '#2c3e50',
      light: '#63b1ff',
    },
    divider: 'rgba(140,140,140,0.12)',
  },
});

export default castingBotTheme;